import { createAssetSchemaHooks } from '@innovyze/lib_asset_schema_react';
import { fetchImportedAssetTypes } from '@innovyze/lib-am-common/Apis';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';

// Pickers only offer what the i360-schema-catalog flag releases and the tenant
// has imported (pass `imported: useImportedAssetTypes()` in the picker rule).
export const {
	useAssetPickerOptions: useReleasedAssetPickerOptions,
	useImportedAssetTypes,
} = createAssetSchemaHooks(
	() => useIsFeatureEnabled('i360-schema-catalog'),
	undefined,
	{ fetchImportedAssetTypes },
);

// Schema reads for an asset type a saved decision tree already references must
// resolve whatever the release flag says, so an open flag value leaves nothing
// gated out.
const OPEN_FLAG = { assets: {} };

export const { useAssetSchema, useAssetTypeSummary, useSystemType } =
	createAssetSchemaHooks(() => OPEN_FLAG);
